import { Cookies } from "react-cookie";
import { Navigate } from "react-router-dom";

interface AuthUserProps {
    children: JSX.Element;
}

export const AuthorizeUser = ({ children }: AuthUserProps) => {
    const cookies = new Cookies();
    const token = cookies.get("user")?.token;

    if (!token) {
        return  <Navigate to={`/`} replace={true}></Navigate>;
    }
    return children;
}